export enum FeatureFlagsEnum {
  DailyManager_SpecialEvents = 'DailyManager_SpecialEvents',
  HubSpotContactSync = 'HubSpotContactSync',
  IgnoreWebSalesPromotions = 'IgnoreWebSalesPromotions',
  UseOrderLimitsWeb = 'UseOrderLimitsWeb',
  UsePriceManagerForMarketingBundlesOnSalesChannels = 'UsePriceManagerForMarketingBundlesOnSalesChannels',
  WebFunnelTelemetry = 'WebFunnelTelemetry',
  SharedFetchState = 'SharedFetchState',
  ShowLowestStartingPriceWindow = 'ShowLowestStartingPriceWindow',
}
export type FeatureFlags = {
  [key in FeatureFlagsEnum]: boolean;
} & { [key: string]: boolean };

export type FeatureFlagsKeys = keyof FeatureFlags;
